import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=0a5d63c5&scoped=true"
import script from "./suggestions.vue?vue&type=script&lang=js"
export * from "./suggestions.vue?vue&type=script&lang=js"
import style0 from "./suggestions.vue?vue&type=style&index=0&id=0a5d63c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d63c5",
  null
  
)

export default component.exports